import React from 'react';

class PrivateIcon extends React.Component {
  render() {
    return (
      <svg
        id="Layer_1"
        xmlns="http://www.w3.org/2000/svg"
        width="28.8"
        height="22.2"
        viewBox="0 0 28.8 22.2"
      >
        <g id="XMLID_601_">
          <g id="XMLID_603_">
            <g id="XMLID_605_">
              <path
                id="XMLID_758_"
                style={{ fill: '#999999' }}
                d="M21.9 13.8l-.4-.1c-.2-.1-3.6-1.4-6.5-1.6 3-.3 5.4-2.9 5.4-6 0-3.3-2.7-6.1-6.1-6.1s-6 2.7-6 6.1c0 3.1 2.4 5.7 5.4 6-2.9.2-6.3 1.5-6.5 1.6l-.4.1L4 21.2l1 .2c.2 0 5.2.8 9.3.8s9-.8 9.3-.8l1-.2-2.7-7.4zM10 6.1c0-2.4 2-4.3 4.3-4.3 2.4 0 4.3 2 4.3 4.3 0 2.4-2 4.3-4.3 4.3-2.4 0-4.3-1.9-4.3-4.3zm4.3 14.3c-2.8 0-6.2-.4-7.9-.7L8.2 15c1-.4 3.9-1.3 6.1-1.3 2.2 0 5.2 1 6.2 1.3l1.8 4.6c-1.7.4-5.1.8-8 .8z"
              />
              <g id="XMLID_742_">
                <path
                  id="XMLID_757_"
                  style={{ fill: '#CCCCCC' }}
                  d="M23.8 7c0 1.7-1.4 3-3 3-.2 0-.4 0-.5-.1-.3.5-.8 1-1.3 1.4.6.2 1.2.4 1.8.4 2.6 0 4.8-2.1 4.8-4.8 0-2.6-2.1-4.8-4.8-4.8h-.5c.3.5.6 1.1.8 1.7 1.5.3 2.7 1.6 2.7 3.2z"
                />
                <path
                  id="XMLID_756_"
                  style={{ fill: '#CCCCCC' }}
                  d="M28.8 20.4l-2.3-6.2-.4-.1c-.1 0-1.7-.6-3.4-1l.1.3.6 1.6c.7.2 1.3.4 1.7.5l1.3 3.5c-.4.1-.9.1-1.4.2l.6 1.6v.1c1.2-.1 2.1-.3 2.1-.3l1.1-.2z"
                />
                <g id="XMLID_748_">
                  <path
                    id="XMLID_755_"
                    style={{ fill: '#CCCCCC' }}
                    d="M8.4 10H8c-1.7 0-3-1.4-3-3 0-1.5 1.1-2.8 2.6-3 .2-.6.5-1.2.8-1.7H8c-2.6-.1-4.7 2-4.7 4.7 0 2.6 2.1 4.8 4.8 4.8.6 0 1.2-.1 1.7-.3-.6-.5-1-1-1.4-1.5z"
                  />
                  <path
                    id="XMLID_749_"
                    style={{ fill: '#CCCCCC' }}
                    d="M3.7 19.2c-.5-.1-1-.1-1.3-.2l1.3-3.5c.4-.1.9-.3 1.6-.5l.6-1.7.1-.1c-1.7.3-3.3.9-3.3 1l-.4.1L0 20.4l1 .2c.1 0 .9.1 2 .3v-.1l.7-1.6z"
                  />
                </g>
              </g>
            </g>
          </g>
        </g>
      </svg>
    );
  }
}

export default PrivateIcon;
